var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-center " },
    [
      _c("v-modal-contents", {
        ref: "modal_contents_agree",
        scopedSlots: _vm._u([
          {
            key: "close",
            fn: function () {
              return [_c("div")]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use__title mt-30 pl-3 " }, [
                  _c("div", { staticClass: "h2_title" }, [
                    _vm._v("Условия использования персональных данных"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use mt-30 " }, [
                  _c("div", { domProps: { innerHTML: _vm._s(_vm.terms) } }),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-30" }, [
                    _c(
                      "button",
                      {
                        staticClass: "px-30 btn_bordered ",
                        on: {
                          click: function ($event) {
                            return _vm.$refs.modal_contents_agree.modal_open()
                          },
                        },
                      },
                      [_vm._v("\n              Прочитал\n            ")]
                    ),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            "content-class": "dialog_custom dialog_rezume",
            width: "516",
            relative: "",
            persistent: "",
          },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: { action: "#", "lazy-validation": "" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                      model: {
                        value: _vm.valid,
                        callback: function ($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid",
                      },
                    },
                    [
                      _c("section", { staticClass: "call" }, [
                        _c("div", { staticClass: "call__inner" }, [
                          _c(
                            "button",
                            {
                              staticClass: "call__close",
                              on: {
                                click: function ($event) {
                                  _vm.dialog = false
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M18 6L6 18",
                                      stroke: "black",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M6 6L18 18",
                                      stroke: "black",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "call__header" }, [
                            _c("h2", { staticClass: "call__title" }, [
                              _vm._v(
                                "\n                    Отправить резюме\n                  "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "call__form" }, [
                            _c(
                              "label",
                              {
                                staticClass: "call__label",
                                attrs: { for: "name" },
                              },
                              [
                                _c("v-text-field", {
                                  staticClass: "call__input",
                                  attrs: {
                                    rules: _vm.nameRulesRu,
                                    required: "",
                                    solo: "",
                                    id: "name",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _vm._v(
                                            "\n                        Ваше имя "
                                          ),
                                          _c("span", [_vm._v("*")]),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                  model: {
                                    value: _vm.name,
                                    callback: function ($$v) {
                                      _vm.name = $$v
                                    },
                                    expression: "name",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "call__label",
                                attrs: { for: "tell" },
                              },
                              [
                                _c("v-text-field", {
                                  staticClass: "call__input ",
                                  attrs: {
                                    rules: _vm.tel_inputRulesRu,
                                    required: "",
                                    solo: "",
                                    id: "tel",
                                    oninput:
                                      "this.value = this.value.replace(/[^\\d+]/g,'');",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _vm._v(
                                            "\n                        Телефон "
                                          ),
                                          _c("span", [_vm._v("*")]),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                  model: {
                                    value: _vm.tel_input,
                                    callback: function ($$v) {
                                      _vm.tel_input = $$v
                                    },
                                    expression: "tel_input",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "call__label",
                                attrs: { for: "email" },
                              },
                              [
                                _c("v-text-field", {
                                  staticClass: "call__input",
                                  attrs: {
                                    required: "",
                                    solo: "",
                                    id: "email",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _vm._v(
                                            "\n                        E-mail\n                      "
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                  model: {
                                    value: _vm.email,
                                    callback: function ($$v) {
                                      _vm.email = $$v
                                    },
                                    expression: "email",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "summary p-12 bg-gray-100 border border-gray-300 drag_form d-flex flex-column justify-content-center",
                                attrs: { id: "summary" },
                                on: {
                                  dragover: _vm.dragover,
                                  dragleave: _vm.dragleave,
                                  drop: _vm.drop,
                                },
                              },
                              [
                                _c("input", {
                                  ref: "file",
                                  staticClass:
                                    "w-px h-px opacity-0 overflow-hidden absolute",
                                  attrs: {
                                    type: "file",
                                    multiple: "",
                                    name: "fields[assetsFieldHandle][]",
                                    id: "assetsFieldHandle",
                                    accept: ".pdf,.jpg,.jpeg,.png",
                                  },
                                  on: { change: _vm.onChange },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "block cursor-pointer",
                                    attrs: { for: "assetsFieldHandle" },
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        "Выберите или перетащите сюда файл в формате PDF, DOC, DOCX, RTF, JPG"
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                this.filelist.length
                                  ? _c(
                                      "ul",
                                      { staticClass: "mt-4" },
                                      _vm._l(
                                        _vm.filelist,
                                        function (file, index) {
                                          return _c(
                                            "li",
                                            {
                                              key: index,
                                              staticClass:
                                                "text-sm p-1 text-left",
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(file.name) +
                                                  "\n                        "
                                              ),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "ml-2 remove_file",
                                                  attrs: {
                                                    type: "button",
                                                    title: "Remove file",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.remove(
                                                        _vm.filelist.indexOf(
                                                          file
                                                        )
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          Удалить\n                        "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "w-100",
                              class: _vm.captchaPassed ? "" : "error-captcha",
                              attrs: { id: "captcha-container" },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form_upload__item" },
                              [
                                _c("v-checkbox", {
                                  attrs: {
                                    rules: [
                                      function (v) {
                                        return !!v || "Это обязательный пункт"
                                      },
                                    ],
                                    required: "",
                                    color: "red",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "customLabelForm" },
                                            [
                                              _vm._v(
                                                "\n                          Я выражаю согласие с "
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void(0);",
                                                    target: "_blank",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.$refs.modal_contents_agree.modal_open(
                                                        "scroll_false"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "условиями использования"
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                " моих персональных данных для обработки данного обращения ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206, Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2), я ознакомлен и выражаю согласие с\n                          "
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "position-relative zi-1",
                                                  attrs: { href: _vm.policy },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.linkOpen(
                                                        _vm.policy
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "Политикой конфиденциальности"
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" и "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "position-relative zi-1",
                                                  attrs: {
                                                    href: _vm.agreement,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.linkOpen(
                                                        _vm.agreement
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "Пользовательским соглашением."
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                  model: {
                                    value: _vm.checkbox,
                                    callback: function ($$v) {
                                      _vm.checkbox = $$v
                                    },
                                    expression: "checkbox",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-checkbox", {
                                  staticClass: "mt-0",
                                  attrs: { color: "red" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "customLabelForm" },
                                            [
                                              _vm._v(
                                                "\n                          Я выражаю согласие на информирование меня о продуктах, акциях, выгодных предложениях, новостях ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206, Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2) и партнеров.\n                        "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                  model: {
                                    value: _vm.consentToInform,
                                    callback: function ($$v) {
                                      _vm.consentToInform = $$v
                                    },
                                    expression: "consentToInform",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "call__box" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "call__btn ",
                                  attrs: { disabled: !_vm.valid },
                                  on: { click: _vm.validate },
                                },
                                [
                                  _vm._v(
                                    "\n                      Отправить\n                    "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }